import moment from "moment";
import { useTranslation } from "react-i18next";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import { amountFormat } from "../services/common.service";
import { Button, Empty, Modal, Table } from "antd";
import { MdOutlineEdit } from "react-icons/md";
import { useEffect, useState } from "react";
import PaginationComponent from "./paginationComponet";
import { useSelector } from "react-redux";
import { selectedAccountSelector } from "../store/selectors/app.selector";

export default function DetailedStatementGrid({
  dataSource,
  accDetails,
  reqValues,
  fetchMoreStatements,
  setRemarkVisible,
  setSelectedDetails,
  remarksIcons,
  noRecords,
}) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [details, setDetails] = useState({});
  const selectedAccount = useSelector(selectedAccountSelector);

  return (
    <>
      <Table
        dataSource={dataSource}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        tableLayout="fixed"
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30", "40", "50", "100", "500"],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} records`,
        }}
        bordered
        sticky={true}
        onRow={(record) => ({
          className:"table-row-pointer",
          onClick: () => {
            console.log(record);
            setDetails(record);
            setVisible(true);
          },
        })}
        columns={[
          {
            title: "Trans Date",
            key: "txnDate",
            width: 150,
            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>
                  {moment(option.txnDate).format("DD-MM-YYYY")}
                </span>
              </>
            ),
          },
          {
            title: "Value Date",
            key: "txnValuedDate",
            width: 150,
            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>
                  {moment(option.txnValuedDate).format("DD-MM-YYYY")}
                </span>
              </>
            ),
          },
          {
            title: "Reference Number",
            key: "refNo",
            width: 200,
            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>{option?.refNo}</span>
              </>
            ),
          },
          {
            title: "Description",
            key: "narration",
            ellipsis: true,

            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>
                  {option?.narration || option?.txnTypeDesc}
                </span>
              </>
            ),
          },
          {
            title: `Debit (${accDetails?.accountCurrency})`,  // "Debit (ZMW)",
            key: "debit",
            align: "right",
            width: 130,
            render: (option) => (
              <span
                style={{ fontSize: "13px" }}
                className={
                  option?.debitOrCredit === "Debit" ? "debit" : "credit"
                }
              >
                {option.debitOrCredit === "Debit" &&
                  amountFormat(option.amount || "", "")}
              </span>
            ),
          },

          {
            title: `Credit (${accDetails?.accountCurrency})`, // "Credit (ZMW)",
            key: "credit",
            align: "right",
            width: 130,
            render: (option) => (
              <span
                style={{ fontSize: "13px" }}
                className={
                  option?.debitOrCredit === "Credit" ? "credit" : "debit"
                }
              >
                {option.debitOrCredit === "Credit" &&
                  amountFormat(option.amount || "", "")}
              </span>
            ),
          },
          {
            title: "Balance",
            key: "balance",
            align: "right",
            width: 200,
            render: (option) => (
              <span style={{ fontSize: "13px", fontFamily: "poppinMedium" }}>
                {amountFormat(option?.balance, option.txnCcy)}
              </span>
            ),
          },
        ]}
      />

      <Modal
        title={""}
        open={visible}
        footer={null}
        width={750}
        closable={false}
        maskClosable={false}
        mask={true}
        centered
      >
        <h3 className="primary-title">
          {t("common.transaction_details", {
            defaultValue: "Transaction Details",
          })}
        </h3>

        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 confirm-details">
            <div className="row" style={{ padding: "0 30px" }}>
             
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>
                  {t("pages.dashboard.transaction_date", {
                    defaultValue: "Transaction Date",
                  })}
                </label>
                <span>
                  {" "}
                  {(details?.txnDate &&
                    moment(details?.txnDate).format("DD-MM-YYYY")) ||
                    "-"}
                </span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>Value Date</label>
                <span>
                  {" "}
                  {(details?.txnDate &&
                    moment(details?.txnValuedDate).format("DD-MM-YYYY")) || "-"}
                </span>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>
                  {" "}
                  {t("pages.gepeg.ref_no", {
                    defaultValue: "Reference Number",
                  })}
                </label>
                <span>{details?.refNo || "-"}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>Transfered Amount</label>
                <span
                  className={
                    details?.debitOrCredit === "Credit" ? "credit" : "debit"
                  }
                >
                  {" "}
                  {amountFormat(details?.amount, details?.txnCcy)}
                </span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-3">
                <label>Balance</label>
                <span> {amountFormat(details?.balance, details?.txnCcy)}</span>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                <label>Description</label>
                <span>{details?.narration}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end mt-5">
          <Button
            onClick={() => setVisible(false)}
            className="secondary-btn"
            type="default"
            size="large"
          >
            {t("buttons.close_btn", { defaultValue: "Close" })}
          </Button>
        </div>
      </Modal>
    </>
  );
}
